(function () {
  'use strict';

  const PDP_ADDONS_STORAGE_KEY = 'customization3d_pdp_addons';
  let sdkPreloadStarted = false;
  let maintenanceCheckPromise = null;

  function isMaintenanceHtml(html) {
    if (!html) return false;
    return html.indexOf('data-c3d-maintenance="true"') !== -1
      || html.indexOf('customization-3d-maintenance') !== -1;
  }

  function checkMaintenanceMode() {
    if (maintenanceCheckPromise) return maintenanceCheckPromise;

    const checkUrl = String(window.C3D_MAINTENANCE_CHECK_URL || '').trim();
    if (!checkUrl) {
      maintenanceCheckPromise = Promise.resolve(false);
      return maintenanceCheckPromise;
    }

    maintenanceCheckPromise = fetch(checkUrl, { credentials: 'same-origin' })
      .then((res) => (res.ok ? res.text() : ''))
      .then((html) => isMaintenanceHtml(html))
      .catch((err) => {
        console.warn('[product-3d-customization-link] maintenance check failed', err);
        return false;
      });

    return maintenanceCheckPromise;
  }

  function hide3dDisplayLink() {
    document.querySelectorAll('[data-customization-3d-link]').forEach((node) => {
      node.remove();
    });
  }

  function ensureC3dLoaderScript() {
    const existing = document.querySelector('script[data-c3d-loader]');
    if (existing) return;

    const src = String(window.C3D_LOADER_SCRIPT_URL || '').trim();
    if (!src) return;

    const linkPreconnect = document.querySelector('link[rel="preconnect"][href="https://spaces.miradoroutdoor.com"]');
    if (!linkPreconnect) {
      const preconnect = document.createElement('link');
      preconnect.rel = 'preconnect';
      preconnect.href = 'https://spaces.miradoroutdoor.com';
      preconnect.crossOrigin = 'anonymous';
      document.head.appendChild(preconnect);
    }

    const dnsPrefetch = document.querySelector('link[rel="dns-prefetch"][href="https://spaces.miradoroutdoor.com"]');
    if (!dnsPrefetch) {
      const prefetch = document.createElement('link');
      prefetch.rel = 'dns-prefetch';
      prefetch.href = 'https://spaces.miradoroutdoor.com';
      document.head.appendChild(prefetch);
    }

    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.dataset.c3dLoader = '1';
    document.body.appendChild(script);
  }

  function preloadC3dSdk() {
    if (sdkPreloadStarted) return;
    sdkPreloadStarted = true;
    ensureC3dLoaderScript();
    if (window.Customization3DLoader?.warmup) {
      window.Customization3DLoader.warmup();
      return;
    }
    const api = (typeof window.CUSTOMIZATION_3D_SDK_FILE_API === 'string' && window.CUSTOMIZATION_3D_SDK_FILE_API.trim())
      ? window.CUSTOMIZATION_3D_SDK_FILE_API.trim()
      : '';
    if (api) {
      fetch(api, { cache: 'no-store', credentials: 'omit' })
        .then((res) => res.json())
        .then((json) => {
          const src = json?.data?.url;
          if (!src || document.querySelector(`link[rel="preload"][href="${src}"]`)) return;
          const link = document.createElement('link');
          link.rel = 'preload';
          link.as = 'script';
          link.href = src;
          document.head.appendChild(link);
        })
        .catch((e) => {
          console.warn('[product-3d-customization-link] sdk warmup', e);
        });
    }
  }

  function parseSlotInput(input) {
    const v = (input.value || '').trim();
    if (!v) return null;
    const parts = v.split(':');
    const variantId = (parts[0] || '').trim();
    const quantity = parseInt(parts[1], 10);
    const productId = (parts[2] || '').trim();
    const productHandle = input.getAttribute('data-product-handle') || '';
    if (!variantId) return null;
    return {
      variantId,
      quantity: !Number.isNaN(quantity) && quantity > 0 ? quantity : 1,
      productId: productId || undefined,
      productHandle: productHandle || undefined,
    };
  }

  function collectPdpAddonSelections() {
    const accessories = [];
    const sidewalls = [];
    document.querySelectorAll('input[name="accessories[]"]').forEach((input) => {
      const row = parseSlotInput(input);
      if (row) accessories.push(row);
    });
    document.querySelectorAll('input[name="sidewalls[]"]').forEach((input) => {
      const row = parseSlotInput(input);
      if (row) sidewalls.push(row);
    });
    return { accessories, sidewalls };
  }

  function persistAddonsForCustomizationPage() {
    try {
      const data = collectPdpAddonSelections();
      if (!data.accessories.length && !data.sidewalls.length) {
        sessionStorage.removeItem(PDP_ADDONS_STORAGE_KEY);
        return;
      }
      sessionStorage.setItem(
        PDP_ADDONS_STORAGE_KEY,
        JSON.stringify({
          v: 1,
          accessories: data.accessories,
          sidewalls: data.sidewalls,
          at: Date.now(),
        })
      );
    } catch (e) {
      console.warn('[product-3d-customization-link] persist addons', e);
    }
  }

  function init() {
    const link = document.querySelector('[data-customization-3d-link]');
    if (!link) return;

    const formId = link.getAttribute('data-form-id');
    const form = formId ? document.getElementById(formId) : null;
    const baseUrl = link.getAttribute('data-base-url');
    const productId = link.getAttribute('data-product-id');
    const productHandle = link.getAttribute('data-product-handle') || '';

    if (!form || !baseUrl || !productId) return;

    const warmSdk = () => preloadC3dSdk();

    link.addEventListener('pointerenter', warmSdk, { passive: true });
    link.addEventListener('focus', warmSdk);
    link.addEventListener('pointerdown', () => {
      warmSdk();
      persistAddonsForCustomizationPage();
    }, true);

    const sync = () => {
      const idInput = form.querySelector('[name="id"]');
      const variantId = idInput?.value;
      if (!variantId) return;

      try {
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set('variant', variantId);
        url.searchParams.set('product_id', productId);
        if (productHandle) {
          url.searchParams.set('handle', productHandle);
        } else {
          url.searchParams.delete('handle');
        }
        link.setAttribute('href', url.toString());
      } catch (e) {
        console.warn('[product-3d-customization-link]', e);
      }
    };

    form.addEventListener('variant:change', sync);
    form.addEventListener('change', (e) => {
      if (e.target && e.target.name === 'id') sync();
    });
    sync();
  }

  function boot() {
    const link = document.querySelector('[data-customization-3d-link]');
    if (!link) return;

    checkMaintenanceMode().then((isMaintenance) => {
      if (isMaintenance) {
        hide3dDisplayLink();
        return;
      }
      init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
